/**
 * @generated SignedSource<<b41b5e30f30cb1f8410d85c9aa99107a>>
 * @relayHash f0a9aeca88571d7a7e8b331fbb363121
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2c84d6f444487b7265847f862fc2321e9dbb8da54cb5d1e05e021b0eec07171

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentSettingsQuery } from './srcVirtualAgentSettingsQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d2c84d6f444487b7265847f862fc2321e9dbb8da54cb5d1e05e021b0eec07171",
    "metadata": {},
    "name": "srcVirtualAgentSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
